'use strict';
import util from './util';
import validator from './validator';
import index from './pages/product/index';
import customModal from './modal';
import analytics from './analytics';

const debounce = (func, delay) => {
    // Using a debounce or throttle mechanism can prevent excessive AJAX requests, which can lead to improved performance and reduced server load. This is particularly important if the function is triggered frequently, as it ensures that only necessary requests are made.
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
};

const showNewsletterModal = debounce(function(isShowFullForm, source) {
    if ($('.newsletter-modal').length === 0) {
        var newsletterURL = util.appendParamToURL(Urls.showNewsletter, 'format', 'ajax');
        if (isShowFullForm) {
            newsletterURL = util.appendParamToURL(Urls.showFullNewsletter, 'format', 'ajax');
        }
        $.ajax({
            type: 'GET',
            url: newsletterURL
        }).done(function (response) {

            if (response !== '' && response !== null && response.error === undefined) {
                customModal.createCustomModal('newsletter-modal', '#modal-custom-placeholder');
                $('.newsletter-modal').find('.modal-body').html(response);
                if (navigator.userAgent.match(/(iPhone|iPad)/)) {
                    $('body').addClass('body-fixed');
                }
                util.bodyPositionFixed('newsletter-modal');
                validator.initForm('.newsletter-modal form');
                $('.newsletter-modal .content').scrollBox();	
                var siteLocation = source ? source : 'Landing';	
                sessionStorage.setItem('gtmNewsletterLocation', siteLocation);        	
                analytics.gtmNewsletterPopup('newsletterPopupOpen', siteLocation);
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.error('AJAX request failed: ' + textStatus, errorThrown);
            // Optionally, provide user feedback or retry logic here
        });
    }
}, 300);
function isNewsletterEnabledHandler() {
    NewsletterModal();
    $('.register-newsletter').removeClass('hide');
    $('.newsletter-success').addClass('hide');

    if (!enableNewsletter) {
        return;
    }

	
    var isViewedNewsletterValid = util.getCookieSelector(Constants.COOKIENAME_NEWSLETTER_VIEWED_FLAG);

		
    var isDisplayedNewsletterValid = util.getCookieSelector(Constants.COOKIENAME_SESSION_FLAG);

    if (isDisplayedNewsletterValid === 'false') {
        return;
    }

    util.setCookie(Constants.COOKIENAME_NEWSLETTER_VIEWED_FLAG, false, newsletterCookieDuration);
	
    setNewsletterCounterCookie();
    signUpEventListener();
	
}

function setNewsletterCounterCookie() {
    var isCookieValid = util.getCookieSelector(Constants.COOKIENAME_NEWSLETTER_PAGEVIEW_COUNT);
    var counterCookie = Number(isCookieValid);

    if (!isCookieValid) {
        counterCookie = 0;
    } else {
        counterCookie += 1;
    }

    util.setCookie(Constants.COOKIENAME_NEWSLETTER_PAGEVIEW_COUNT, counterCookie, newsletterCookieDuration);
	
    // Display newsletter popup if page view threshold is reached	
    var cookieConcentFlag = util.getCookieSelector(Constants.COOKIENAME_COOKIECONSENT_FLAG);
    var sessionConcentFlag = util.getCookieSelector(Constants.COOKIENAME_SESSION_FLAG);
        
    if (cookieConcentFlag == 'true' && sessionConcentFlag == 'true' && counterCookie >= pageViewsToNewsletter && $('.calendarlayout').length == 0) {
    		showNewsletterModal(false);
    		util.setCookie(Constants.COOKIENAME_SESSION_FLAG, false, 10);
    }
}

function signUpEventListener() {
    $('#modal-custom-placeholder')
        .on('submit', '.modal-content .news-letter-form', function (e) {
            e.preventDefault();

            var emailAddress = $('.modal-content input').val();
            validateNewsletterEmail(true, emailAddress);
        })

        .on('keyup blur', '.modal-content input', function (e) {
            var emailAddress = $(this).val();

            $('.modal-content button').prop('disabled', false);
            $('.modal-content button').css('color', '');

            if (!emailAddress.length) {
                $('.modal-content button').prop('disabled', true);
                $('.modal-content button').css('color', '#FFFFFF');
            }
        });
}

function newsletterHeaderHandler() {
    $('#modal-custom-placeholder').on('submit', '.newsletter-content-wrapper .news-letter-form:not(#pdNewsLetter)', function (e) {
        e.preventDefault();

        const emailAddress = $('.news-letter-form input.email').val();
        validateNewsletterEmail(false, emailAddress);
    }).on('click', '.newsletter-success-popup .code-block', function(){
	  const copyText = $('#newsletter-promo-code').text();
	  const $temp = $('<input>').val(copyText).appendTo('body').select();
	  document.execCommand('copy');
	  $temp.remove();
	  if ($('#to-copy').length > 0) {
		  $('#to-copy').hide();
		  $('#copied').css('display', 'flex');
	  }	
    });
}

function pdNewsletterComponentHandler() {
    $('#modal-custom-placeholder').on('submit', '.pd-newsletter', function (e) {
        e.preventDefault(); 
        const pdNewsletter = $(this);       
        const emailAddress = pdNewsletter.find('input.email').val();
        const fname = pdNewsletter.find('input[name="newsletterfname"]').val();
        const lname = pdNewsletter.find('input[name="newsletterlname"]').val();
        validatePDNewsletterEmail(emailAddress, fname, lname);
    });
}

function validateNewsletterEmail(isModal, emailAddress) {
    var validateClass = '.news-letter-form';

    if (isModal) {
        validateClass = '.modal-content';
    }

    $(validateClass + ' input').removeAttr('aria-invalid');
    $(validateClass + ' input').removeAttr('aria-describedby');
    $(validateClass + ' input').removeAttr('class');
    $(validateClass + ' span').remove();

    //  Commented these line on code as validateEmail function is not present in util	
    //	if (!util.validateEmail(emailAddress)) {
    //		var errorMessage;

    //		if (isModal) {
    //			errorMessage = [
    //				'<span id="-error" class="error">',
    //				Resources.VALIDATE_EMAIL,
    //				'</span>'
    //			].join('');

    //			$(validateClass + ' .promotions-container').after(errorMessage);
    //			$(validateClass + ' button').prop('disabled', true);
    //		} else {
    //			errorMessage = [
    //				'<span id="-error" class="error">',
    //				Resources.VALIDATE_EMAIL,
    //				'</span>'
    //			].join('');
    //
    //			$(validateClass + ' input').before(errorMessage);
    //		}
    //	}

    if (isModal) {
        setHasViewedNewsletterCookie(true);
    }

    if ($('.news-letter-form').length > 0) {
        var dataToPost = 'dwfrm_newsletter_subscribe=dwfrm_newsletter_subscribe' + '&' + $('.news-letter-form').serialize() + '&source=' + (isModal ? 'modal' : 'header');
        $.ajax({
            type: 'POST',
            url: $('.news-letter-form').attr('action'),
            async: false,
            data: dataToPost,
            success: function (response) {
                if (isModal) {
                    $(document).trigger('clicknewsletter', {
                        'siteloc': 'pop-up'
                    });
                } else {
                    $('.newsletter-content-wrapper').html(response);
                    if ((/Mobi|Android/i).test(navigator.userAgent)) {
                        $('.newsletter-modal .content').scrollBox();
                    }
                    $(document).trigger('clicknewsletter', {
                        'siteloc': 'navbar'
                    });
                    $('#newsletter-modal').trigger('resize');
                }
                if (window.universal_variable !== undefined && !window.universal_variable.user.hasOwnProperty('user_id')) {
                    window.universal_variable.user.email = emailAddress;
                }
            }
        });
    }

}

function NewsletterModal() {
    $('#modal-custom-placeholder').on('click', '.newsletter-modal-btn, .newsletter-full-modal-btn', function (e) {
        e.preventDefault();
        let isShowFullForm = false;
		
        if (this.classList.contains('newsletter-full-modal-btn')) {
            isShowFullForm = true;
        }
		
        showNewsletterModal(isShowFullForm, 'Footer');
    }).on('click', '.newsletter-modal .continue-shopping .primary', function (e) {
        $('.newsletter-modal .modal-close').trigger('click');
    }).on('click', '.modal-close, .modal-close-outer', function () {
        const newsLetterLocation = sessionStorage.getItem('gtmNewsletterLocation'); 			
        if(newsLetterLocation !== null) {
            analytics.gtmNewsletterPopup('newsletterPopupClose', newsLetterLocation);
            sessionStorage.removeItem('gtmNewsletterLocation');
        }	
    });
}

function validatePDNewsletterEmail(emailAddress, fname, lname) {
    var validateClass = '.news-letter-form';

    $(validateClass + ' input').removeAttr('aria-invalid');
    $(validateClass + ' input').removeAttr('aria-describedby');
    $(validateClass + ' input').removeAttr('class');
    $(validateClass + ' span').remove();

    if (!util.validateEmail(emailAddress)) {
        var errorMessage;
        var $emailInputElem = $('input[name$=_newsletter_email]');
        errorMessage = ['<span id="-error" class="error">',Resources.VALIDATE_EMAIL,'</span>'].join('');

        $emailInputElem.before(errorMessage);
    }
    
    var formSerliazeData;
    formSerliazeData = $('#pdNewsLetter').serialize();
    
    if ($('.news-letter-form').length > 0){
        var sourceValue = 'pdcomponent'
    	$.ajax({
            type: 'POST',
            url: $('.news-letter-form').attr('action'),
            async: false,
            data: formSerliazeData +'&email='+ emailAddress +'&source='+sourceValue+'&fname='+fname+'&lname='+lname,
            success: function (response) {
            	if (typeof response.success != 'undefined' && response.success==false){
                    $('.newsletter-content').html(response.error);
                    $(document).trigger('clicknewsletter',{'siteloc':'navbar'});
            	} else {
	                if (!response.error){
	                    $('.newsletter-success-cntr').html($('.newsletter-success').html());
	                    $('.newsletter-content').html('');
	                }
	                if (window.universal_variable !== undefined && !window.universal_variable.user.hasOwnProperty('user_id')){
	                	window.universal_variable.user.email = emailAddress;
	                }
            	}
            }
        });
    }
    
}

function setHasViewedNewsletterCookie(val) {	
    util.setCookie(Constants.COOKIENAME_NEWSLETTER_VIEWED_FLAG, val, newsletterCookieDuration);
}

export const isNewsletterEnabled = isNewsletterEnabledHandler;
export const newsletterHeader = newsletterHeaderHandler;
export const pdNewsletterComponent = pdNewsletterComponentHandler;

export default {
    isNewsletterEnabled,
    newsletterHeader,
    pdNewsletterComponent
}